import React, { useState } from 'react'
import { useRef } from 'react';
import { useEffect } from 'react';
import { Col, Row } from 'react-bootstrap';
import { Form, Input, InputPicker, SelectPicker } from 'rsuite';
import { getAdditionalStructurals, getEngineerExamDiscipline, getFirstExamDiscipline, getStates } from '../../../../services/Shared/codeTable.service';
import YesNoRadioOption from '../../../Shared/RadioButton/YesNoRadioOption';

function PeEiAdditionalInformationSection() {
    const [appDiscipline, setAppDiscipline] = useState([]);
    const [states, setStates] = useState([])
    const [examDiscipline, setExamDiscipline] = useState([])
    const [additionalStructurals, setAdditionalStructurals] = useState([])
    const stateSearch = (userInput, label, dataItem) => {
        if (label.toLowerCase().startsWith(userInput.toLowerCase()) || !userInput)
            return true;
    }
    useEffect(() => {
        getStates().then(setStates);
        getEngineerExamDiscipline().then(setExamDiscipline);
        getFirstExamDiscipline().then(setAppDiscipline);
        getAdditionalStructurals().then(setAdditionalStructurals);
    }, [])


    return <>
        <Row className="mb-3">
            <Col>
                <Form.Group>
                    <Form.ControlLabel><b>Application Disc.</b></Form.ControlLabel>
                    <Form.Control
                        name="applicationDiscipline"
                        data={appDiscipline}
                        accepter={SelectPicker}
                        searchable={false}
                        block />
                </Form.Group>
            </Col>
            <Col>
                <Form.Group>
                    <Form.ControlLabel><b>Comity State</b></Form.ControlLabel>
                    <Form.Control
                        accepter={InputPicker}
                        block
                        data={states}
                        searchBy={stateSearch}
                        name="comityState" />
                </Form.Group>
            </Col>
            <Col>
                <Form.Group>
                    <Form.ControlLabel><b>EI Cert. Date</b></Form.ControlLabel>
                    <Form.Control type='date' name="eiCertificationDate" />
                </Form.Group>
            </Col>
        </Row>
        <Row className="mb-3">
            <Col>
                <Form.Group>
                    <Form.ControlLabel><b>EI Cert. #</b></Form.ControlLabel>
                    <Form.Control name="eiCertificationNumber" />
                </Form.Group>
            </Col>
            <Col>
                <Form.Group>
                    <Form.ControlLabel><b>FE Exam Date</b></Form.ControlLabel>
                    <Form.Control type='date' name="feExamDate" />
                </Form.Group>
            </Col>
            <Col>
                <Form.Group>
                    <Form.ControlLabel><b>FE Exam State</b></Form.ControlLabel>
                    <Form.Control
                        accepter={InputPicker}
                        block
                        data={states}
                        searchBy={stateSearch}
                        name="feExamState" />
                </Form.Group>
            </Col>
        </Row>
        <Row className="mb-3">
            <Col>
                <Form.Group>
                    <Form.ControlLabel><b>PE Exam Date</b></Form.ControlLabel>
                    <Form.Control type='date' name="peExamDate" />
                </Form.Group>
            </Col>
            <Col>
                <Form.Group>
                    <Form.ControlLabel><b>PE Exam State</b></Form.ControlLabel>
                    <Form.Control
                        accepter={InputPicker}
                        block
                        data={states}
                        searchBy={stateSearch}
                        name="peExamState" />
                </Form.Group>
            </Col>
            <Col>
                <Form.Group>
                    <Form.ControlLabel><b>PE Lic State</b></Form.ControlLabel>
                    <Form.Control
                        accepter={InputPicker}
                        block
                        data={states}
                        searchBy={stateSearch}
                        name="peLicenseState" />
                </Form.Group>
            </Col>
        </Row>
        <Row className="mb-3">
            <Col>
                <Form.Group>
                    <Form.ControlLabel><b>PE Lic Date</b></Form.ControlLabel>
                    <Form.Control type='date' name="peLicenseDate" />
                </Form.Group>
            </Col>
            <Col>
                <Form.Group>
                    <Form.ControlLabel><b>PE Lic #</b></Form.ControlLabel>
                    <Form.Control name="peLicenseNumber" />
                </Form.Group>
            </Col>
            <Col>
                <Form.Group>
                    <Form.ControlLabel><b>PE Exam Discipline</b></Form.ControlLabel>
                    <Form.Control
                        name="peExamDiscipline"
                        data={examDiscipline}
                        accepter={InputPicker}
                        searchable={true}
                        block />
                </Form.Group>
            </Col>
        </Row>
        <Row className="mb-3">
            <Col>
                <Form.Group>
                    <Form.ControlLabel><b>Discipline 2</b></Form.ControlLabel>
                    <Form.Control
                        name="peExamDiscipline2"
                        data={appDiscipline}
                        accepter={InputPicker}
                        searchable={true}
                        block />
                </Form.Group>
            </Col>
            <Col>
                <Form.Group>
                    <Form.ControlLabel><b>Dis. 2 Reg. Date</b></Form.ControlLabel>
                    <Form.Control type='date' name="peExamDiscipline2RegistrationDate" />
                </Form.Group>
            </Col>
            <Col>
                <Form.Group>
                    <Form.ControlLabel><b>Dis. 2 Exam State</b></Form.ControlLabel>
                    <Form.Control
                        accepter={InputPicker}
                        block
                        data={states}
                        searchBy={stateSearch}
                        name="peExamDiscipline2ExamState" />
                </Form.Group>
            </Col>
        </Row>
        <Row className="mb-3">
            <Col>
                <Form.Group>
                    <Form.ControlLabel><b>Model Law</b></Form.ControlLabel>
                    <YesNoRadioOption radioName="isModelLaw" />
                </Form.Group>
            </Col>
            <Col>
                <Form.Group>
                    <Form.ControlLabel><b>Act 2</b></Form.ControlLabel>
                    <YesNoRadioOption radioName="isAct2" />
                </Form.Group>
            </Col>
            <Col>
                <Form.Group>
                    <Form.ControlLabel><b>PE by Endorsement</b></Form.ControlLabel>
                    <YesNoRadioOption radioName="isByEndorsement" />
                </Form.Group>
            </Col>
        </Row>
        <Row className="mb-3">
            <Col>
                <Form.Group>
                    <Form.ControlLabel><b>Additional Structural</b></Form.ControlLabel>
                    <Form.Control
                        accepter={InputPicker}
                        block
                        data={additionalStructurals}
                        searchBy={stateSearch}
                        name="additionalStructural1" />
                </Form.Group>
            </Col>
            <Col>
                <Form.Group>
                    <Form.ControlLabel><b>Additional Structural Exam Date</b></Form.ControlLabel>
                    <Form.Control type='date' name="additionalStructuralExamDate1" />
                </Form.Group>
            </Col>
            <Col>
            </Col>
        </Row>
        <Row className="mb-3">
            <Col>
                <Form.Group>
                    <Form.ControlLabel><b>Additional Structural</b></Form.ControlLabel>
                    <Form.Control
                        accepter={InputPicker}
                        block
                        data={additionalStructurals}
                        searchBy={stateSearch}
                        name="additionalStructural2" />
                </Form.Group>
            </Col>
            <Col>
                <Form.Group>
                    <Form.ControlLabel><b>Additional Structural Exam Date</b></Form.ControlLabel>
                    <Form.Control type='date' name="additionalStructuralExamDate2" />
                </Form.Group>
            </Col>
            <Col>
            </Col>
        </Row>
    </>;
}
export default PeEiAdditionalInformationSection;